import BIRTHDAY_DARK_24 from './assets/BIRTHDAY_DARK_24.svg?url'
import BIRTHDAY_DARK_48 from './assets/BIRTHDAY_DARK_48.svg?url'
import BIRTHDAY_LIGHT_24 from './assets/BIRTHDAY_LIGHT_24.svg?url'
import BIRTHDAY_LIGHT_48 from './assets/BIRTHDAY_LIGHT_48.svg?url'
import EDUCATION_DARK_24 from './assets/EDUCATION_DARK_24.svg?url'
import EDUCATION_DARK_48 from './assets/EDUCATION_DARK_48.svg?url'
import EDUCATION_LIGHT_24 from './assets/EDUCATION_LIGHT_24.svg?url'
import EDUCATION_LIGHT_48 from './assets/EDUCATION_LIGHT_48.svg?url'
import EXTRA_CASH_DARK_24 from './assets/EXTRA_CASH_DARK_24.svg?url'
import EXTRA_CASH_DARK_48 from './assets/EXTRA_CASH_DARK_48.svg?url'
import EXTRA_CASH_LIGHT_24 from './assets/EXTRA_CASH_LIGHT_24.svg?url'
import EXTRA_CASH_LIGHT_48 from './assets/EXTRA_CASH_LIGHT_48.svg?url'
import FOOD_DARK_24 from './assets/FOOD_DARK_24.svg?url'
import FOOD_DARK_48 from './assets/FOOD_DARK_48.svg?url'
import FOOD_LIGHT_24 from './assets/FOOD_LIGHT_24.svg?url'
import FOOD_LIGHT_48 from './assets/FOOD_LIGHT_48.svg?url'
import GAMES_DARK_24 from './assets/GAMES_DARK_24.svg?url'
import GAMES_DARK_48 from './assets/GAMES_DARK_48.svg?url'
import GAMES_LIGHT_24 from './assets/GAMES_LIGHT_24.svg?url'
import GAMES_LIGHT_48 from './assets/GAMES_LIGHT_48.svg?url'
import GIFT_DARK_24 from './assets/GIFT_DARK_24.svg?url'
import GIFT_DARK_48 from './assets/GIFT_DARK_48.svg?url'
import GIFT_LIGHT_24 from './assets/GIFT_LIGHT_24.svg?url'
import GIFT_LIGHT_48 from './assets/GIFT_LIGHT_48.svg?url'
import ILLNESS_DARK_24 from './assets/ILLNESS_DARK_24.svg?url'
import ILLNESS_DARK_48 from './assets/ILLNESS_DARK_48.svg?url'
import ILLNESS_LIGHT_24 from './assets/ILLNESS_LIGHT_24.svg?url'
import ILLNESS_LIGHT_48 from './assets/ILLNESS_LIGHT_48.svg?url'
import LIVING_DARK_24 from './assets/LIVING_DARK_24.svg?url'
import LIVING_DARK_48 from './assets/LIVING_DARK_48.svg?url'
import LIVING_LIGHT_24 from './assets/LIVING_LIGHT_24.svg?url'
import LIVING_LIGHT_48 from './assets/LIVING_LIGHT_48.svg?url'
import RAINY_DAY_DARK_24 from './assets/RAINY_DAY_DARK_24.svg?url'
import RAINY_DAY_DARK_48 from './assets/RAINY_DAY_DARK_48.svg?url'
import RAINY_DAY_LIGHT_24 from './assets/RAINY_DAY_LIGHT_24.svg?url'
import RAINY_DAY_LIGHT_48 from './assets/RAINY_DAY_LIGHT_48.svg?url'
import TECHNOLOGY_DARK_24 from './assets/TECHNOLOGY_DARK_24.svg?url'
import TECHNOLOGY_DARK_48 from './assets/TECHNOLOGY_DARK_48.svg?url'
import TECHNOLOGY_LIGHT_24 from './assets/TECHNOLOGY_LIGHT_24.svg?url'
import TECHNOLOGY_LIGHT_48 from './assets/TECHNOLOGY_LIGHT_48.svg?url'
import TRAVEL_DARK_24 from './assets/TRAVEL_DARK_24.svg?url'
import TRAVEL_DARK_48 from './assets/TRAVEL_DARK_48.svg?url'
import TRAVEL_LIGHT_24 from './assets/TRAVEL_LIGHT_24.svg?url'
import TRAVEL_LIGHT_48 from './assets/TRAVEL_LIGHT_48.svg?url'
import VACATION_DARK_24 from './assets/VACATION_DARK_24.svg?url'
import VACATION_DARK_48 from './assets/VACATION_DARK_48.svg?url'
import VACATION_LIGHT_24 from './assets/VACATION_LIGHT_24.svg?url'
import VACATION_LIGHT_48 from './assets/VACATION_LIGHT_48.svg?url'

type EmojiVariants = {
  light: {
    svg24: string
    svg48: string
  }
  dark: {
    svg24: string
    svg48: string
  }
}

export type EmojiIconId =
  | 'FOOD'
  | 'EDUCATION'
  | 'ILLNESS'
  | 'RAINY_DAY'
  | 'LIVING'
  | 'EXTRA_CASH'
  | 'VACATION'
  | 'GIFT'
  | 'GAMES'
  | 'TRAVEL'
  | 'TECHNOLOGY'
  | 'BIRTHDAY'

// SVGs taken from https://www.figma.com/design/t4iPqqSG5MWLcVvPyc0A5i/01-Arcade---Savings-Emojis
export const Emojis: Record<EmojiIconId, EmojiVariants> = {
  FOOD: {
    light: { svg24: FOOD_LIGHT_24, svg48: FOOD_LIGHT_48 },
    dark: { svg24: FOOD_DARK_24, svg48: FOOD_DARK_48 },
  },
  EDUCATION: {
    light: { svg24: EDUCATION_LIGHT_24, svg48: EDUCATION_LIGHT_48 },
    dark: { svg24: EDUCATION_DARK_24, svg48: EDUCATION_DARK_48 },
  },
  ILLNESS: {
    light: { svg24: ILLNESS_LIGHT_24, svg48: ILLNESS_LIGHT_48 },
    dark: { svg24: ILLNESS_DARK_24, svg48: ILLNESS_DARK_48 },
  },
  RAINY_DAY: {
    light: { svg24: RAINY_DAY_LIGHT_24, svg48: RAINY_DAY_LIGHT_48 },
    dark: { svg24: RAINY_DAY_DARK_24, svg48: RAINY_DAY_DARK_48 },
  },
  LIVING: {
    light: { svg24: LIVING_LIGHT_24, svg48: LIVING_LIGHT_48 },
    dark: { svg24: LIVING_DARK_24, svg48: LIVING_DARK_48 },
  },
  EXTRA_CASH: {
    light: { svg24: EXTRA_CASH_LIGHT_24, svg48: EXTRA_CASH_LIGHT_48 },
    dark: { svg24: EXTRA_CASH_DARK_24, svg48: EXTRA_CASH_DARK_48 },
  },
  VACATION: {
    light: { svg24: VACATION_LIGHT_24, svg48: VACATION_LIGHT_48 },
    dark: { svg24: VACATION_DARK_24, svg48: VACATION_DARK_48 },
  },
  GIFT: {
    light: { svg24: GIFT_LIGHT_24, svg48: GIFT_LIGHT_48 },
    dark: { svg24: GIFT_DARK_24, svg48: GIFT_DARK_48 },
  },
  GAMES: {
    light: { svg24: GAMES_LIGHT_24, svg48: GAMES_LIGHT_48 },
    dark: { svg24: GAMES_DARK_24, svg48: GAMES_DARK_48 },
  },
  TRAVEL: {
    light: { svg24: TRAVEL_LIGHT_24, svg48: TRAVEL_LIGHT_48 },
    dark: { svg24: TRAVEL_DARK_24, svg48: TRAVEL_DARK_48 },
  },
  TECHNOLOGY: {
    light: { svg24: TECHNOLOGY_LIGHT_24, svg48: TECHNOLOGY_LIGHT_48 },
    dark: { svg24: TECHNOLOGY_DARK_24, svg48: TECHNOLOGY_DARK_48 },
  },
  BIRTHDAY: {
    light: { svg24: BIRTHDAY_LIGHT_24, svg48: BIRTHDAY_LIGHT_48 },
    dark: { svg24: BIRTHDAY_DARK_24, svg48: BIRTHDAY_DARK_48 },
  },
} as const
